import {
  freetext_default
} from "./chunk-OZAUPKH3.js";

// src/modules/freetext/freetext.tsx
import Title from "@a24/ui/Title";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var mFreetext = ({
  _id,
  className = "",
  content,
  labels,
  sequence
}) => {
  if (!content?.heading && !content?.text) return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    content?.heading && /* @__PURE__ */ jsx(
      Title,
      {
        className: "heading-xl pt-[9.5rem] pb-10 md:pt-[12rem] md:pb-14 max-md:mx-6 max-2xl:mx-16",
        level: "h1",
        text: content?.heading
      }
    ),
    content?.text && /* @__PURE__ */ jsx(
      "section",
      {
        className: `${className}${content?.heading ? " pt-0 md:pt-0" : ""}`,
        "data-module-sequence": sequence,
        "data-module-type": "mFreetext",
        id: _id,
        children: /* @__PURE__ */ jsx(
          freetext_default,
          {
            className: "freetext-richtext",
            id: `${_id}_freetext`,
            text: content?.text
          }
        )
      }
    )
  ] });
};
var freetext_default2 = mFreetext;

export {
  freetext_default2 as freetext_default
};
